import React, { useState, useMemo, useEffect } from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Container, UncontrolledTooltip, FormGroup, Table, Label, Input, Button, Row, Col, Card, CardBody, FormFeedback, Spinner } from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';
import { Link } from "react-router-dom";
import { createShiftGroup, deleteShiftGroup, fetchShiftGroups, fetchShifts } from "store/actions";
import Select from "react-select"; // For dropdown
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const ShiftGroup = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const dispatch = useDispatch();
    const [editingIndex, setEditingIndex] = useState(null);
    const [groupId, setGroupId] = useState(null);
    const [authDetails, setAuthDetails] = useState(null);
    const [groups, setGroups] = useState({ groupName: "", shifts: [] });

    const { shifts } = useSelector((state) => state.shiftReducer || {});
    const { shiftGroups, loading, error, success } = useSelector((state) => state.shiftGroupReducer || {});
    console.log(shiftGroups)

    // Fetch data on component mount
    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        console.log("Final Employee Object:", authUserDetails);
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchShifts(unitId));
        dispatch(fetchShiftGroups(unitId));
    }, [dispatch]);

    // Validation Schema
    const validationSchema = Yup.object({
        groupName: Yup.string()
            .required("Group Name is required")
            .max(50, "Group Name must not exceed 50 characters")
            .matches(
                /^[a-zA-Z0-9 ]+$/,
                "Group Name allows only alphabets, numbers and spaces"
            ),
        shifts: Yup.array()
            .of(
                Yup.object({
                    shiftCode: Yup.string().required("Shift Code is required"),
                    shiftName: Yup.string().required("Shift Name is required"),
                    order: Yup.number()
                        .typeError("Order must be a number")
                        .required("Order is required"),
                })
            )
            .min(1, "At least one shift is required"),
    });

    // Initial Form State
    const initialValues = {
        groupName: "",
        shifts: [{ shiftCode: "", shiftName: "", order: "" }],
    };

    // Handle Form Submit
    const handleSubmit = (values, { resetForm, setSubmitting }) => {
        try {
            setSubmitting(true); // Start loading state
            debugger
            const formData = new FormData();

            // Append Group Details

            formData.append("group_name", values.groupName);
            formData.append("unit_id", authDetails.unit_id);
            formData.append("created_by", authDetails.user_id);

            // Prepare Shift Group List
            const listShiftGroup = values.shifts.map((shift) => ({
                shift_id: shift.shiftid,
                shift_name: shift.shiftName,
                order: shift.order,
            }));

            formData.append("items", JSON.stringify({ listShiftGroup }));
            console.log("Dispatching Shift Group Saga with Data:", Object.fromEntries(formData.entries()));

            if (editingIndex) {
                formData.append("group_id", groupId)
            } else {
                formData.append("group_id", 0); // New holiday
            }

            // Dispatch the action
            dispatch(createShiftGroup(formData));

            // Reset form after submission
            resetForm();
            setEditingIndex(null);
        } catch (error) {
            console.error('Error submitting shift group:', error);
        } finally {
            setSubmitting(false); // Stop loading state
        }
    };


    const handleEditGroup = (group) => {
        setGroupId(group.groupid)
        console.log(group)
        if (!group || !group.shifts || !group.shiftids) {
            console.error("Invalid group data:", group);
            return;
        }

        // Convert "shiftids" and "shifts" from string to an array
        const shiftNamesArray = group.shifts.split(", "); // Splitting by ", "
        const shiftCodeArray = group.scode.split(", "); // Splitting by ", "
        const shiftIdsArray = group.shiftids.split(", "); // Splitting by ", "

        // Combine shift ID and Name into objects
        const formattedShifts = shiftIdsArray.map((id, index) => ({
            shiftid: id,
            shiftCode: shiftCodeArray[index] || "",
            shiftName: shiftNamesArray[index] || "", // Avoid undefined values
            order: index + 1, // You may update this logic for actual order
        }));

        // Set state for Formik
        setEditingIndex(group.groupid);
        setGroups({
            groupName: group.groupName || "",
            shifts: formattedShifts, // Now this is an array of objects
        });
    };


    const handleToggleStatus = (row) => {
        console.log('row  > ', row)
        Swal.fire({
            title: 'Are you sure?',
            html: `You are about to delete ${row.groupName} group`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            reverseButtons: false,
            dangerMode: true,
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append("group_id", row.groupid);
                formData.append("unit_id", authDetails?.unit_id);
                formData.append("createdby", authDetails?.user_id);
                dispatch(deleteShiftGroup(formData));
            }
        });
    };

    // const columns = useMemo(
    //     () => [
    //         {
    //             Header: "Action",
    //             Cell: (cellProps) => {
    //                 const isActive = cellProps.row.original.isActive;
    //                 return (
    //                     <div className="d-flex gap-3">
    //                         <Link
    //                             to="#"
    //                             style={{ color: isActive ? "green" : "red" }}
    //                             onClick={() => handleToggleStatus(cellProps.row.original)}
    //                         >
    //                             <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
    //                             <UncontrolledTooltip placement="top" target="deletetooltip">
    //                                 Delete
    //                             </UncontrolledTooltip>
    //                         </Link>
    //                         <Link
    //                             to="#"
    //                             className="text-success"
    //                             onClick={() => handleEditGroup(cellProps.row.original)}
    //                         >
    //                             <i className="bx bxs-edit font-size-18" id="edittooltip" />
    //                             <UncontrolledTooltip placement="top" target="edittooltip">
    //                                 Edit
    //                             </UncontrolledTooltip>
    //                         </Link>
    //                     </div>
    //                 );
    //             },
    //         },
    //         {
    //             Header: "S.No",
    //             Cell: ({ row }) => shifts.length - row.index,
    //             className: "serial-no",
    //             applyHeaderClass: true,
    //         },
    //         {
    //             Header: "Group Name",
    //             accessor: "groupName", // Group Name
    //         },
    //         {
    //             Header: "Shifts",
    //             accessor: "shifts"
    //         }

    //     ],
    //     [shiftGroups]
    // );

    const columns = useMemo(() => {
        const actionColumn =
            (canEdit || canDelete)
            ? {
                Header: "Action",
                Cell: (cellProps) => {
                    const { groupId, isActive } = cellProps.row.original;
                    const safeId = groupId || cellProps.row.id; // fallback unique id

                    return (
                    <div className="d-flex gap-3">
                        {/* Edit - only if allowed */}
                        {canEdit && (
                        <Link
                            to="#"
                            className="text-success"
                            onClick={() => handleEditGroup(cellProps.row.original)}
                        >
                            <i
                            className="bx bxs-edit font-size-18"
                            id={`edit-tooltip-${safeId}`}
                            />
                            <UncontrolledTooltip
                            placement="top"
                            target={`edit-tooltip-${safeId}`}
                            >
                            Edit
                            </UncontrolledTooltip>
                        </Link>
                        )}
                        
                        {/* Delete - only if allowed */}
                         {canDelete && (
                        <Link
                            to="#"
                            style={{ color: isActive ? "green" : "red" }}
                            onClick={() => handleToggleStatus(cellProps.row.original)}
                        >
                            <i
                            className="mdi mdi-delete font-size-18"
                            id={`delete-tooltip-${safeId}`}
                            />
                            <UncontrolledTooltip
                            placement="top"
                            target={`delete-tooltip-${safeId}`}
                            >
                            {isActive ? "Mark Inactive" : "Mark Active"}
                            </UncontrolledTooltip>
                        </Link>
                        )}
                    </div>
                    );
                },
                }
            : null;

        return [
            ...(actionColumn ? [actionColumn] : []),
            {
            Header: "S.No",
            Cell: ({ row }) => shiftGroups.length - row.index,
            className: "serial-no",
            applyHeaderClass: true,
            },
            { Header: "Group Name", accessor: "groupName" },
            { Header: "Shifts", accessor: "shifts" },
        ];
        }, [shiftGroups, canEdit, canDelete]);


    return (
        <Container fluid className="page-content">
            <Breadcrumbs title="Setup" breadcrumbItem="Shift Group" />
            <Row>
                <Col lg={12}>
                {(canCreate || canEdit) && (
                    <Card>
                        <CardBody>
                            {/* Formik Form */}
                            <Formik
                                initialValues={editingIndex !== null && groups ? groups : { groupName: "", shifts: [{ shiftCode: "", shiftName: "", order: "" }] }}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ values, handleChange, handleBlur, setFieldValue, errors, touched, isSubmitting, resetForm }) => (
                                    <Form>
                                        {/* Group Name Field */}
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label>Group Name  <span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="groupName"
                                                        type="text"
                                                        maxLength={50}
                                                        value={values.groupName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        invalid={touched.groupName && !!errors.groupName}
                                                    />
                                                    <FormFeedback>{errors.groupName}</FormFeedback>
                                                </FormGroup>
                                            </Col></Row>


                                        {/* Shifts Table */}
                                        <div className="table-responsive " style={{ overflow: "visible" }}>
                                        <FieldArray name="shifts">
                                            {({ push, remove }) => (
                                                <Table bordered className="custom-header-css table table-bordered table-hover">
                                                    <thead className="table-light table-nowrap">
                                                        <tr>
                                                            <th>Delete</th>
                                                            <th>Shift Code  <span className="text-danger">*</span></th>
                                                            <th>Shift Name</th>
                                                            <th>Order</th>
                                                            <th>Add</th> {/* Add column for "+" icon */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {values.shifts.map((shift, index) => (
                                                            <tr key={index}>
                                                                {/* Delete Icon */}
                                                                <td className="text-center">
                                                                    {values.shifts.length > 1 && (
                                                                        <Link to="#" onClick={() => remove(index)} style={{ fontSize: "14px" }}>
                                                                            <i className="mdi mdi-delete font-size-18 text-danger" />
                                                                        </Link>
                                                                    )}
                                                                </td>

                                                                {/* Shift Code - Dropdown */}
                                                                <td className="col-6">
                                                                    
                                                                    <CustomSelect
                                                                        options={shifts.map((s) => ({
                                                                            value: s.shiftcode,
                                                                            shiftid: s.shiftid,
                                                                            label: `${s.shiftcode} - ${s.shiftName} [${s.shiftIn} - ${s.shiftOut}]`,
                                                                            shiftName: s.shiftName,
                                                                        }))}
                                                                        value={
                                                                            values.shifts[index].shiftCode
                                                                                ? {
                                                                                    value: values.shifts[index].shiftCode,
                                                                                    label: `${values.shifts[index].shiftCode}`,
                                                                                }
                                                                                : null
                                                                        }
                                                                        onChange={(selectedOption) => {
                                                                            if(selectedOption){
                                                                            setFieldValue(`shifts[${index}].shiftCode`, selectedOption.value);
                                                                            setFieldValue(`shifts[${index}].shiftid`, selectedOption.shiftid);
                                                                            setFieldValue(`shifts[${index}].shiftName`, selectedOption.shiftName);
                                                                            setFieldValue(`shifts[${index}].order`, index + 1);
                                                                            }
                                                                            else{
                                                                                setFieldValue(`shifts[${index}].shiftCode`, "");
                                                                                setFieldValue(`shifts[${index}].shiftid`, "");
                                                                                setFieldValue(`shifts[${index}].shiftName`, "");
                                                                                setFieldValue(`shifts[${index}].order`, index + 1);
                                                                            }
                                                                            
                                                                        }}
                                                                    />
                                                                </td>

                                                                {/* Shift Name - Display */}
                                                                <td className="col-4">
                                                                    <Input
                                                                        type="text"
                                                                        name={`shifts[${index}].shiftName`}
                                                                        value={shift.shiftName}
                                                                        readOnly
                                                                    />
                                                                </td>

                                                                {/* Order - Input */}
                                                                <td className="col-2">
                                                                    <Input
                                                                        type="number"
                                                                        name={`shifts[${index}].order`}
                                                                        value={shift.order}
                                                                        onChange={handleChange}
                                                                        readOnly
                                                                    />
                                                                </td>

                                                                {/* Plus Button in the same row */}
                                                                {index === values.shifts.length - 1 && (
                                                                    <td className="col-2 text-center">
                                                                        <Link
                                                                            to="#"
                                                                            onClick={() => {

                                                                                push({ shiftCode: "", shiftName: "", order: values.shifts.length + 1 });
                                                                            }}
                                                                            style={{ fontSize: '18px' }}
                                                                        >
                                                                            <i className="mdi mdi-plus font-size-18" />
                                                                        </Link>
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            )}
                                        </FieldArray>
                                        </div>

                                        <div className="text-end mt-3 mb-3">
                                            {/* <Button type="submit" color="primary" className="me-2" disabled={isSubmitting}>
                                                {isSubmitting ? (
                                                    <>
                                                        <Spinner size="sm" /> Processing...
                                                    </>
                                                ) : (
                                                    editingIndex !== null ? "Update" : "Save"
                                                )}
                                            </Button> */}
                                            <Button
                                                type="submit"
                                                color="primary"
                                                className="me-2 btn button-save"
                                                disabled={isSubmitting}  // Disable button while submitting
                                            >
                                                <i className="fas fa-save me-1" />
                                                {isSubmitting ? (
                                                    <>
                                                        <Spinner size="sm" /> Processing...
                                                    </>
                                                ) : (
                                                    editingIndex !== null ? "Update" : "Save"
                                                )}
                                            </Button>
                                            <Button type="reset" color="secondary" onClick={() => {
                                                setEditingIndex(null); // Reset editing state
                                                setGroupId(null); // Reset group ID
                                                setGroups({ groupName: "", shifts: [{ shiftCode: "", shiftName: "", order: "" }] }); // Reset local state
                                                resetForm(); // Reset Formik form
                                            }}
                                            className="btn button-cancel ">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>


                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </CardBody>
                    </Card>
                )}
                    <Card>
                        <CardBody>
                            {/* Table Section */}
                            <TableContainer
                                columns={columns}
                                data={shiftGroups && shiftGroups.length > 0 ? shiftGroups : []}
                                isGlobalFilter={true} // Enable search
                                customPageSize={10} // Default page size
                                className="custom-header-css" // Custom styling
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ShiftGroup;
